import React, { useRef, useState } from 'react'
import Button from '@/v2/components/common/Button'

const SignaturePad = ({ value, onChange }) => {
  const canvasRef = useRef(null)
  const drawing = useRef(false)
  const [hasInk, setHasInk] = useState(!!value)

  const point = e => {
    const rect = canvasRef.current.getBoundingClientRect()
    return { x: e.clientX - rect.left, y: e.clientY - rect.top }
  }

  const start = e => {
    drawing.current = true
    const ctx = canvasRef.current.getContext('2d')
    if (!ctx) return
    const { x, y } = point(e)
    ctx.beginPath()
    ctx.moveTo(x, y)
  }

  const move = e => {
    if (!drawing.current) return
    const ctx = canvasRef.current.getContext('2d')
    if (!ctx) return
    const { x, y } = point(e)
    ctx.lineTo(x, y)
    ctx.strokeStyle = '#111827'
    ctx.lineWidth = 2
    ctx.stroke()
  }

  const end = () => {
    if (!drawing.current) return
    drawing.current = false
    setHasInk(true)
    // PNG keeps the canvas's transparent background; JPEG encoded it as black.
    onChange(canvasRef.current.toDataURL('image/png'))
  }

  const clear = () => {
    const canvas = canvasRef.current
    if (canvas) {
      const ctx = canvas.getContext('2d')
      if (ctx && ctx.clearRect) {
        ctx.clearRect(0, 0, canvas.width, canvas.height)
      }
    }
    setHasInk(false)
    onChange('')
  }

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={520}
        height={160}
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        style={{
          width: '100%',
          maxWidth: 520,
          height: 160,
          border: '1px solid #d1d5db',
          borderRadius: 8,
          touchAction: 'none',
        }}
      />
      <div style={{ marginTop: 8 }}>
        <Button type="button" variant="outlined" onClick={clear} disabled={!hasInk}>
          Clear
        </Button>
      </div>
    </div>
  )
}

export default SignaturePad
